module.exports = __webpack_public_path__ + "img/1.89ab17b7.png";